import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* eslint-disable @typescript-eslint/no-non-null-assertion */

import { buildBalloon, clear, getShapeBalloon, handleCloseClick } from './helpers';

/** Настройки всплывающей подсказки яндекс карт */

export var YBalloon = /*#__PURE__*/function () {
  function YBalloon() {
    var _this = this;
    _classCallCheck(this, YBalloon);
    /** Добавляет объект всплывающей подсказки на карту */
    _defineProperty(this, "addBalloon", function (_ref) {
      var balloon = _ref.balloon,
        _ref$yMap = _ref.yMap,
        yBalloon = _ref$yMap.balloon,
        geoObjects = _ref$yMap.geoObjects,
        yInstance = _ref.yInstance,
        object = _ref.object;
      var objectManager = new yInstance.ObjectManager();
      var objectId = object.options.id;
      if (yBalloon.isOpen()) {
        yBalloon.close(true);
      }
      yBalloon.open(balloon.coordinates, {}, {
        autoPan: true,
        offset: balloon.offset,
        contentLayout: yInstance.templateLayoutFactory.createClass(balloon.html),
        targetObjectId: objectId
      });
      geoObjects.add(objectManager);
    });
    /**
     * Добавляет кастомный балун на карту
     * Для возможности закрывать балун, обязательно нужна кнопка с id close
     */
    _defineProperty(this, "addBalloonWithContainer", function (_ref2) {
      var _ref2$balloon = _ref2.balloon,
        offset = _ref2$balloon.offset,
        coordinates = _ref2$balloon.coordinates,
        _ref2$balloon$closeSe = _ref2$balloon.closeSelector,
        closeSelector = _ref2$balloon$closeSe === void 0 ? '#close' : _ref2$balloon$closeSe,
        html = _ref2$balloon.html,
        _ref2$yMap = _ref2.yMap,
        yBalloon = _ref2$yMap.balloon,
        geoObjects = _ref2$yMap.geoObjects,
        yInstance = _ref2.yInstance;
      var objectManager = new yInstance.ObjectManager({
        geoObjectOpenBalloonOnClick: false
      });
      yBalloon.open(coordinates, {}, {
        offset: offset,
        layout: _this.createCustomBalloonTemplate({
          yInstance: yInstance,
          html: html,
          closeSelector: closeSelector,
          offset: offset
        })
      });
      geoObjects.add(objectManager);
    });
  }
  return _createClass(YBalloon, [{
    key: "createCustomBalloonTemplate",
    value: function createCustomBalloonTemplate(_ref3) {
      var yInstance = _ref3.yInstance,
        html = _ref3.html,
        closeSelector = _ref3.closeSelector,
        offset = _ref3.offset;
      return yInstance.templateLayoutFactory.createClass(html, {
        build: function build() {
          buildBalloon.call(this, closeSelector);
        },
        clear: clear,
        getShape: function getShape() {
          return getShapeBalloon.call(this, yInstance, offset);
        }
      }, {
        handleCloseClick: handleCloseClick
      });
    }
  }]);
}();